import React from "react";

const BottomSection = ({ showImage, presenter, bottomRef }) => {
  const content = presenter.getBottomSectionContent();

  return (
    <section
      ref={bottomRef}
      className="bottom-section text-white py-5 position-relative"
    >
      <div className="container" style={{ maxWidth: "1200px" }}>
        <div className="row">
          {/* Text Column */}
          <div className="col-lg-6 d-flex flex-column justify-content-center mb-4 mb-lg-0">
            <h6 className="text-uppercase" style={{ opacity: 0.75 }}>
              {content.subtitle}
            </h6>
            <h2 className="fw-bold">{content.title}</h2>
            <p className="mb-0" style={{ maxWidth: "500px" }}>
              {content.description}
            </p>
          </div>

          {/* Image Column */}
          <div className="col-lg-6 position-relative">
            <div
              className={`bottom-section-image-wrapper position-absolute w-100 text-center ${
                showImage ? "slide-from-left" : ""
              }`}
              style={{
                top: "-80px", // Surplus upward
                zIndex: 1,
              }}
            >
              <img
                src={content.image}
                alt="Bottom Illustration"
                className="img-fluid bottom-section-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BottomSection;
